// src/firebase.js - Complete Firebase Configuration
import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Your actual Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB75OXkRf7pOUT2qtbBq7Hx5kESPliId8E",
  authDomain: "bike-rental-management-5334e.firebaseapp.com",
  projectId: "bike-rental-management-5334e",
  storageBucket: "bike-rental-management-5334e.firebasestorage.app",
  messagingSenderId: "63541440595",
  appId: "1:63541440595:web:e21927f59e7c1e369856a6",
  measurementId: "G-1C0K8RRVN7"
};

// Alternative: Use environment variables (recommended for security)
// Make sure to create a .env file in your project root with these variables:
/*
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};
*/

// Initialize Firebase
let app;
let auth;
let db;
let storage;

try {
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
  db = getFirestore(app);
  storage = getStorage(app);
  
  console.log('✅ Firebase initialized successfully');
  console.log('🔥 Project ID:', firebaseConfig.projectId);
  console.log('📦 Storage bucket:', firebaseConfig.storageBucket);
} catch (error) {
  console.error('❌ Firebase initialization failed:', error);
  console.warn('⚠️ Running in offline mode - localStorage will be used as fallback');
  
  // Set to null so other parts of the app know Firebase is unavailable
  auth = null;
  db = null;
  storage = null;
}

// Development mode - Firebase Emulators (optional)
// Uncomment these lines if you're using Firebase emulators for development
if (process.env.NODE_ENV === 'development' && window.location.hostname === 'localhost') {
  try {
    // Uncomment and configure these if using emulators:
    
    // Auth Emulator (usually runs on port 9099)
    // connectAuthEmulator(auth, "http://localhost:9099", { disableWarnings: true });
    
    // Firestore Emulator (usually runs on port 8080)  
    // connectFirestoreEmulator(db, 'localhost', 8080);
    
    // console.log('🧪 Connected to Firebase emulators for development');
  } catch (error) {
    console.warn('⚠️ Could not connect to emulators, using production Firebase:', error.message);
  }
}

// Test Firebase connection
const testFirebaseConnection = async () => {
  if (!auth || !db) {
    console.log('📱 Firebase not available - using localStorage mode');
    return false;
  }
  
  try {
    // Simple connectivity test
    await db._delegate._databaseId;
    console.log('🌐 Firebase connectivity test passed');
    return true;
  } catch (error) {
    console.warn('⚠️ Firebase connectivity test failed:', error.message);
    return false;
  }
};

// Run connectivity test
testFirebaseConnection().then(isConnected => {
  if (isConnected) {
    console.log('🔥 Firebase is ready for multi-tenant authentication');
  } else {
    console.log('📱 Operating in localStorage-only mode');
  }
});

export { auth, db, storage, testFirebaseConnection };
export default app;